import { AppColors } from "@/styles/colors";
import { Button, CloseButton, Dialog, Portal, Text } from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import { LightMode } from "../ui/color-mode";

interface Props {
  openConfirm: boolean;
  setOpenConfirm: Dispatch<SetStateAction<boolean>>;
  handleAccept?: () => void;
  loadingAccept?: boolean;
  title: string;
  subtitle: string;
}

export const ConfirmModal = ({
  openConfirm,
  setOpenConfirm,
  handleAccept,
  loadingAccept,
  subtitle,
  title,
}: Props) => {
  return (
    <Dialog.Root
      placement="center"
      lazyMount
      open={openConfirm}
      onOpenChange={(e) => setOpenConfirm(e.open)}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <LightMode>
            <Dialog.Content data-testid="confirm-modal">
              <Dialog.Header paddingY="16px" paddingLeft="24px">
                <Dialog.Title
                  fontWeight={600}
                  color={AppColors.GRAY_TEXT}
                  fontSize="18px"
                  data-testid="confirm-modal-title"
                >
                  {title}
                </Dialog.Title>
              </Dialog.Header>
              <Dialog.Body paddingX="24px" paddingY="8px">
                <Text
                  fontSize="16px"
                  color={AppColors.GRAY_TEXT}
                  data-testid="confirm-modal-subtitle"
                >
                  {subtitle}
                </Text>
              </Dialog.Body>
              <Dialog.Footer paddingY="16px" paddingX="24px">
                <Dialog.ActionTrigger asChild>
                  <Button variant="outline" paddingX="16px" fontWeight={600}>
                    Cancelar
                  </Button>
                </Dialog.ActionTrigger>
                <Button
                  paddingX="16px"
                  bgColor={AppColors.GREEN_PRIMARY}
                  fontWeight={600}
                  onClick={handleAccept}
                  loading={loadingAccept}
                  disabled={loadingAccept}
                  data-testid="confirm-modal-accept-button"
                >
                  Aceptar
                </Button>
              </Dialog.Footer>
              <Dialog.CloseTrigger asChild>
                <CloseButton size="sm" />
              </Dialog.CloseTrigger>
            </Dialog.Content>
          </LightMode>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
